var map = {
	"./word-bg1.png": "7f9c",
	"./word-bg2.png": "1cd5",
	"./word-bg3.png": "6d5b",
	"./word-bg4.png": "21e4",
	"./word-bg5.png": "4e3c",
	"./word-bg6.png": "56ec",
	"./word-bg7.png": "0e4d",
	"./word-bg8.png": "b48c",
	"./word-bg9.png": "6aa8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "39de";